import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Signup from "../views/User/Signup.vue";
import Signin from "../views/User/Signin.vue";
import Form from "../views/User/Form.vue";
import Personal from "../views/User/Personal.vue";
import Contest from "../components/layout/Contest.vue";
import About from "../components/layout/About.vue";
import Formeval from "../views/Evaluator/Formeval.vue";
import Contact from "../components/layout/Contact.vue";
import Admin from "../views/Admin.vue";
import NotVerified from "../views/User/NotVerified.vue";
import Deactivated from "../views/User/Deactivated.vue";

import AuthGuard from "./auth-guard";

import store from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Homes",
    component: Home
  },
  {
    path: "/Home",
    name: "Home",
    component: Home
  },
  {
    path: "/not-verified",
    name: "NotVerified",
    component: NotVerified,
    meta: { auth: ["aplicant", "admin"] }
  },
  {
    path: "/deactivated",
    name: "Deactivated",
    component: Deactivated,
    meta: { auth: ["aplicant", "admin"] }
  },
  {
    path: "/Contact",
    name: "Contact",
    component: Contact
  },
  {
    path: "/signup",
    name: "Signup",
    component: Signup
  },
  {
    path: "/personal",
    name: "Personal",
    component: Personal,
    meta: { auth: ["aplicant", "admin"] }
  },
  {
    path: "/contest",
    name: "Contest",
    component: Contest,
    meta: { auth: ["aplicant", "admin"] }
  },
  {
    path: "/signin",
    name: "Signin",
    component: Signin
  },
  {
    path: "/form",
    name: "Form",
    component: Form,
    meta: { auth: ["aplicant", "admin"] },
    beforeEnter: async (to, from, next) => {
      let user = store.getters.user;

      if (user.role === "admin") {
        next();
      } else {
        const completedPersonal = store.getters.completedPersonal;

        // console.log(completedPersonal);

        if (completedPersonal) next();
        else next("/personal");
      }
    }
  },
  {
    path: "/formeval",
    name: "Formeval",
    component: Formeval,
    meta: { auth: ["evaluator", "el presidente", "admin"] }
  },
  {
    path: "/about",
    name: "About",
    component: About
  },
  {
    path: "/admin",
    name: "Admin",
    component: Admin,
    meta: { auth: ["admin"] }
  }
];

const router = new VueRouter({
  routes
});

router.beforeEach(AuthGuard);

export default router;
